export const SALARY_DRAFT_ACCEPTED = "SALARY_DRAFT_ACCEPTED";
export const SALARY_DRAFT_REJECTED = "SALARY_DRAFT_REJECTED";
export const SALARY_DRAFT_FORWARDED = "SALARY_DRAFT_FORWARDED";
